module.exports = __webpack_public_path__ + "static/img/300.a9cef952.png";